import config from 'config';

const Person = (props) => {
  return `
  {
    "@context": "https://schema.org/",
    "@type": "Person",
    "name": "${props.name}",
    "url": "${config.host + props.page.pathName}",
    "image": "${props.image}",
    "sameAs": [${props.profiles.map((profile) => `"${profile}"`)}],
    "jobTitle": "${props.jobTitle}",
    "worksFor": {
      "@type": "Organization",
      "name": "Starling Bank"
    }
  }
`;
};

export default Person;
